import { Box, Theme } from '@mui/material';
import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AutoLogin, Features, Footer, ForgotPassword, Help, Menu, Mobile, Pricing, ResetPassword, Signin, Signup, ValidateResetPassword, Welcome, Unsubscribe } from './pages';
import DeletedAccount from './pages/DeletedAccount';

const landingPageAliases = [
  '', // the classic home page
  'landing', // used for facebook marketing
  'app', // used in the May 2019 english video
  'promo', // used for the jdekrec flyers and distribution to arenas
  'sports', // georges laraque on twitter, instagram, facebook
  'sport', // georges laraque on twitter, instagram, facebook
];

function App() {
  // TODO Port
  /*
      # Auto login if remember me is enabled and homepage is requested
    if !HTML_ERROR && !session.isAuthenticated() && localStorageService.get( 'X-Remember-Me' )? && ($location.path() == '/' or $location.path() == '')
      $location.path( '/schedule' )
   */

  return (
    <>
      <Suspense fallback={<div />}>
        <Menu />
        <Box
          id="toto"
          sx={{
            marginTop: (theme: Theme) => {
              return {
                xs: theme.menu.mobile.height,
                sm: theme.menu.desktop.height,
              };
            },
          }}
        >
          <Routes>
            {landingPageAliases.map((path) => (
              <Route path={path} element={<Welcome />} key={path} />
            ))}
            <Route path="features" element={<Features />} />
            <Route path="signup" element={<Signup />} />
            <Route path="signin" element={<Signin />} />
            <Route path="forgotPassword" element={<ForgotPassword />} />
            <Route path="validateResetPassword" element={<ValidateResetPassword />} />
            <Route path="resetPassword" element={<ResetPassword />} />
            <Route path="mobile" element={<Mobile />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="help" element={<Help />} />
            <Route path="unsubscribe" element={<Unsubscribe />} />
            <Route path="deletedAccount" element={<DeletedAccount />} />
            {/*<Route path="schedule" element={<Schedule/>}/>*/}
            <Route path="*" element={<AutoLogin />} />
          </Routes>
        </Box>
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
